import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import VueCookies from "vue-cookies";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/utils/global-mixin";
import "@/directives";
import "@/lib/custom-elements/vega-lite";
import "./styles/fonts.css";
import "./styles/colors.css";
import "./styles/common.css";
import "./styles/boostrap-override.css";
import "./styles/SLDS-icons.css";
import i18n from "./plugins/i18n";

Vue.config.productionTip = false;
Vue.use(VueCookies);

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
